<div class="loader" *ngIf="isLoading$ | async">
	<img src="assets/gifs/loader.gif" alt="loader">
</div>
